import React, {useEffect, useState} from "react";
import Application from './application/Application';
import {ApplicationProvider} from './application/ApplicationContext';
import "bootstrap-icons/font/bootstrap-icons.css";
import {BrowserRouter, Link, Route, Routes} from "react-router-dom";

import "primereact/resources/themes/bootstrap4-light-blue/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons

import {Config} from "./config/config";
import {AppRoutes} from "./routes/AppRoutes";
import "./App.scss";

function App() {

  return (
    <ApplicationProvider>
      <Application>
        <div className="rwa-app">
          <BrowserRouter basename={Config.baseFolder}>
            <AppRoutes />
          </BrowserRouter>
        </div>
      </Application>
    </ApplicationProvider>
  );
};

export default App;
